import type { ComponentProps } from "react";
import { cn } from "~/shared/lib";

type ErrorInputProps = ComponentProps<"div">;

export function ErrorInput({ children, className, ...props }: ErrorInputProps) {
  if (!children) {
    return null;
  }

  return (
    <div {...props} className={cn("text-sm text-red-500", className)}>
      {children}
    </div>
  );
}
